<msc-header [company]="company" [access]="access"></msc-header>
<msc-sidebar [me]="me" [company]="company" [access]="access" [sidebar]="sidebar"></msc-sidebar>

<section infinite-scroll [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="0"
    (scrolled)="loadMoreEmit()" infiniteScrollTrigger>
    <router-outlet></router-outlet>
</section>

